export default function ClientsPanel({ clients }) {
  return (
    <div className="card-surface overflow-hidden" data-testid="clients-panel">
      <table className="w-full text-sm">
        <thead className="bg-bone/60">
          <tr className="text-left">
            <th className="px-5 py-3 eyebrow">Name</th>
            <th className="px-5 py-3 eyebrow">Contact</th>
            <th className="px-5 py-3 eyebrow">Last service area</th>
            <th className="px-5 py-3 eyebrow">Bookings</th>
            <th className="px-5 py-3 eyebrow">Last seen</th>
          </tr>
        </thead>
        <tbody>
          {clients.length === 0 && (
            <tr><td colSpan="5" className="px-5 py-10 text-center text-muted2">No clients yet.</td></tr>
          )}
          {clients.map((c) => (
            <tr key={c.email} className="border-t border-black/5" data-testid={`client-row-${c.email}`}>
              <td className="px-5 py-4 font-medium">{c.name}</td>
              <td className="px-5 py-4 text-xs">
                <div>{c.email}</div>
                <div className="text-muted2">{c.phone}</div>
              </td>
              <td className="px-5 py-4 text-xs">{c.last_city}, {c.last_state}</td>
              <td className="px-5 py-4 font-heading">{c.bookings_count}</td>
              <td className="px-5 py-4 text-xs text-muted2">{new Date(c.last_seen_at).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
